import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Services.css';

import AutoWashIcon from '../assets/Automatic-car-wash.svg';
import CeramicIcon from '../assets/Ceramic Coating .svg';
import GrapheneIcon from '../assets/Graphene Coating.svg';
import BoropheneIcon from '../assets/Borophene Coating .svg';
import PaintProtectIcon from '../assets/Paint protection films .svg';
import WindshieldIcon from '../assets/Windshield protection films .svg';
import SprayableIcon from '../assets/Sprayable PPF .svg';
import DetailingIcon from '../assets/Detailing Services .svg';
import deepIcon from '../assets/deepicon.svg'
import SteamIcon from '../assets/steamicon.svg'
import BikeIcon from '../assets/bikeicon.svg'
import WindowIcon from '../assets/window.svg'
import PaintingIcon from '../assets/paintingicon.svg'
import CarIcon from '../assets/carIcon.svg'

const defaultServices = [
  { icon: AutoWashIcon, title: 'Automatic Car Wash' },
  { icon: CeramicIcon, title: 'Ceramic Coating' },
  { icon: GrapheneIcon, title: 'Graphene Coating' },
  { icon: BoropheneIcon, title: 'Borophene Coating' },
  { icon: PaintProtectIcon, title: 'Paint Protection Films' },
  { icon: WindshieldIcon, title: 'Windshield Protection Films' },
  { icon: SprayableIcon, title: 'Sprayable PPF' },
  { icon: DetailingIcon, title: 'Detailing Services' },
  { icon: deepIcon, title: 'Deep Interior Cleaning Services' },
  { icon: SteamIcon, title: 'Steam Wash' },
  { icon: BikeIcon, title: 'Bike Detailing' },
  { icon: WindowIcon, title: 'Window Films' },
  { icon: PaintingIcon, title: 'Painting and Denting services' },
  { icon: CarIcon, title: 'Car Modifications' },
];

// Mapping from display title to slug (based on Navbar)
const serviceTitleToSlug = {
  'Automatic Car Wash': 'automatic-car-wash',
  'Ceramic Coating': 'ceramic-coating',
  'Graphene Coating': 'graphene-coating',
  'Borophene Coating': 'borophene-coating',
  'Paint Protection Films': 'paint-protection-film',
  'Windshield Protection Films': 'windshield-protection-film',
  'Sprayable PPF': 'sprayable-ppf',
  'Detailing Services': 'detailing-services',
  'Deep Interior Cleaning Services': 'deep-interior-cleaning',
  'Steam Wash': 'steam-wash',
  'Bike Detailing': 'bike-detailing',
  'Window Films': 'window-films',
  'Painting & Denting Services': 'painting-denting-services',
  'Car Modifications': 'car-modifications',
};

const Services = ({ services = defaultServices }) => {
  const navigate = useNavigate();
  const handleServiceClick = (service) => {
    const slug = serviceTitleToSlug[service.title];
    if (slug) {
      navigate(`/services/${slug}`);
    }
  };

  return (
    <section className="services-section container">
      <div className="services-label">Our Services</div>

      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        slidesPerView={7}
        spaceBetween={30}
        loop={true}
        pagination={{ clickable: true }}
        navigation
        className="services-swiper"
        breakpoints={{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 7 },
        }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
      >
        {services.map((service, idx) => (
          <SwiperSlide key={service.title}>
            <div
              className={`service-item${idx === 0 ? ' ' : ''}`}
              style={{ cursor: 'pointer' }}
              onClick={() => handleServiceClick(service)}
            >
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <div className="service-title">{service.title}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Services;
